import type { ReactNode } from "react";

/** Ob ein Kind etwas zeichnet — leere Teile einer Karte (Rumpf, Fuß) entfallen ganz. */
export function hasContent(node: ReactNode): boolean {
  return node !== undefined && node !== null && node !== false && node !== "" && !(Array.isArray(node) && node.every((n) => !hasContent(n as ReactNode)));
}

/**
 * Eine Karte (`pf-card`): Kopf mit Titel, Hinweis und Aktionen, Rumpf, Fuß.
 * Dieselbe Struktur wie `card()` der Vanilla-Fassung — app.css hängt daran.
 */
export function Card({
  title, hint, actions, foot, flush = false, danger = false, id, children,
}: {
  title?: ReactNode;
  hint?: ReactNode;
  actions?: ReactNode;
  foot?: ReactNode;
  /** Rumpf ohne Innenabstand (Tabellen, Listen). */
  flush?: boolean;
  danger?: boolean;
  id?: string;
  children?: ReactNode;
}) {
  return (
    <section className={`pf-card${danger ? " pf-card--danger" : ""}`} id={id}>
      {hasContent(title) && (
        <header className="pf-card__head">
          <div className="pf-card__titles">
            <h2 className="pf-card__title">{title}</h2>
            {hasContent(hint) && <p className="pf-card__hint">{hint}</p>}
          </div>
          {hasContent(actions) && <div className="pf-row">{actions}</div>}
        </header>
      )}
      {hasContent(children) && <div className={`pf-card__body${flush ? " pf-card__body--flush" : ""}`}>{children}</div>}
      {hasContent(foot) && <footer className="pf-card__foot">{foot}</footer>}
    </section>
  );
}
